module.exports = __webpack_public_path__ + "img/beatsaber_01.9b78583f.jpg";